"use strict";

var _defineProperty = require("/home/runner/work/kourikoulom/kourikoulom/node_modules/@babel/runtime/helpers/defineProperty.js");

var _require = require("@pwops/core"),
    registerMixin = _require.registerMixin;

var _size = function _size(width, height) {
  var _ref;

  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return _ref = {}, _defineProperty(_ref, "".concat(prefix).concat(prefix ? "W" : "w", "idth"), width), _defineProperty(_ref, "".concat(prefix).concat(prefix ? "H" : "h", "eight"), height), _ref;
};

registerMixin("size", function () {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
  return _size(width, height);
});
registerMixin("minSize", function () {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
  return _size(width, height, "min");
});
registerMixin("maxSize", function () {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
  return _size(width, height, "max");
});